
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 19 17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M17 0H2A1.5 1.5 0 00.5 1.5v10.164A1.465 1.465 0 002 13.125h1.875v2.625a.75.75 0 001.177.617l4.682-3.242H17a1.5 1.5 0 001.5-1.5V1.5A1.5 1.5 0 0017 0zm0 11.438a.188.188 0 01-.188.187H9.5a.75.75 0 00-.427.133l-3.698 2.56v-1.943a.75.75 0 00-.75-.75H2.187A.188.188 0 012 11.437v-9.75a.187.187 0 01.188-.187h14.624a.188.188 0 01.188.188v9.75zM5 5.625h9a.75.75 0 100-1.5H5a.75.75 0 000 1.5zM14 9H5a.75.75 0 010-1.5h9A.75.75 0 1114 9z","fill":"#BD2C43"}})])
          )
        }
      }
    